// extracted by mini-css-extract-plugin
export default {"infoText":"ConsentDownload_infoText__PT65j","buttonContainer":"ConsentDownload_buttonContainer__lHcxj"};